import { useSelector } from 'react-redux';

import { getMainAccountId } from '../../store/account';
import { useAllFeatures } from '@repo/features';
import { getImpersonateId } from '../../store/user';
import { getJWTToken } from '../../utils/jwt';

const wrappedUseAllFeatures = () => {
  const mainAccountId = useSelector(getMainAccountId);
  const impersonationId = useSelector(getImpersonateId);
  const token = getJWTToken();

  return useAllFeatures(mainAccountId, {
    token: token || null,
    impersonateId: impersonationId || null,
  });
};

export default wrappedUseAllFeatures;
